export default {
  'menu.welcome': '欢迎',
  'menu.dashboard': '数据统计',
  'menu.search': '搜索',
  'menu.showcase': '案例管理',
  'menu.showcase.list': '案例列表',
  'menu.showcase.create': '创建案例',
  'menu.showcase.edit': '编辑案例',
  'menu.showcase.detail': '案例详情',
  'menu.category': '分类管理',
  'menu.showcase.category': '分类管理',
  'menu.customerShare': '客户分享管理',
  'menu.customerShare.list': '分享列表',
  'menu.customerShare.create': '创建分享',
  'menu.customerShare.edit': '编辑分享',
  'menu.showcase.customerShare': '客户分享管理',
  'menu.showcase.customerShare.list': '分享列表',
  'menu.showcase.customerShare.create': '创建分享',
  'menu.showcase.customerShare.edit': '编辑分享',
  // 文档管理
  'menu.docManagement': '文档管理',
  'menu.docManagement.groups': '文档组',
  'menu.docManagement.createGroup': '新建文档组',
  'menu.docManagement.editGroup': '编辑文档组',
  'menu.docManagement.standaloneDocs': '文档列表',
  'menu.docManagement.editStandaloneDoc': '编辑文档',
  'menu.docManagement.createStandaloneDoc': '新建文档',
  'menu.docManagement.documents': '组内文档',
  'menu.docManagement.createDocument': '新建文档',
  'menu.docManagement.editDocument': '编辑文档',
  'menu.docManagement.knowledgeBase': '知识库',
  'menu.docManagement.createKnowledgeBase': '新建知识库',
  'menu.docManagement.editKnowledgeBase': '编辑知识库',
  'menu.docManagement.trash': '文档回收站',
  'menu.docManagement.trashDetail': '文档回收站',
  'menu.docManagement.apiKeys': 'API Key 管理',
  'menu.docManagement.apiKeyLogs': 'API Key 日志',
  'menu.team': '团队',
  'menu.team.detail': '团队详情',
  'menu.settings': '系统设置',
  'menu.settings.basic': '基本设置',
  'menu.agent': 'Agent 智能',
  'menu.agent.health': '文档健康度',
  'menu.agent.suggestions': 'AI 建议',
  'menu.agent.config': '策略配置',
  'menu.agent.audit': '审计日志',
  'menu.agent.tokenUsage': 'Token 消耗',
  'menu.agent.memory': '记忆管理',
  'menu.agent.conversationLogs': '会话日志',
  'menu.agent.llmProviders': 'LLM 平台管理',
  'menu.admin': '系统管理',
  'menu.admin.users': '用户管理',
  'menu.admin.roles': '角色管理',
  'menu.admin.menus': '菜单管理',
  'menu.admin.appVersions': 'App 版本管理',
  'menu.admin.dataPermissions': '数据权限',
  'menu.admin.systemStats': '访问统计',
  'menu.login': '登录',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
};
